import { useRef } from 'react';
import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import redLine from 'src/assets/memberships/red-line.svg';

import type { Props } from '../../shared/types';
import { AmountSelectorSunrise } from '../AmountSelectorSunrise';

import { useMembershipAwarenessPlacementConfig } from './hooks/useMembershipAwarenessPlacementConfig';
import { useTracking } from './hooks/useTracking';

export const MembershipAwarenessSunrise: React.FC<Props> = ({ sourceLocation, slug, signed }) => {
	const element = useRef<HTMLElement>(null);
	const {
		data: { headlinePart1, headlinePart2, body, ctaQuestion, heroImage },
	} = useMembershipAwarenessPlacementConfig();
	useTracking({ sourceLocation, element });

	return (
		<div
			id="membership-awareness"
			className="rounded-medium bg-gradient-background-light-2 elevation-low flex flex-col gap-4 pt-3.5 md:pt-4"
			data-qa="membership-awareness"
		>
			<Image src={heroImage} alt="main onsite image" className="max-h-[100px] w-full object-cover md:block" />
			<div className="flex flex-col gap-6 p-6 md:flex-row md:gap-10">
				<div className="text-typography-strong flex h-full flex-1 flex-col gap-6 md:gap-4">
					<div className="text-typography-strong flex flex-col">
						<Image alt="" src={redLine} width="35" height="20" />
						<Text variant="heading" size="large">
							{headlinePart1}
						</Text>
						<Text variant="heading" size="x-small">
							{headlinePart2}
						</Text>
					</div>
					<div className="flex flex-col gap-4">
						<Text>{body}</Text>
						<Text fontWeight="bold">{ctaQuestion}</Text>
					</div>
				</div>
				<div className="align-center flex-1">
					<AmountSelectorSunrise sourceLocation={sourceLocation} slug={slug} signed={signed} />
				</div>
			</div>
		</div>
	);
};
